<template>
  <div v-if="sensors.length>0" class="water-parameter">
    <div class="title">
      <div class="parallelogram">
        <span>水质参数</span>
      </div>
      <div class="parallelogram extra-line">
        <span>线条</span>
      </div>
    </div>
    <ul class="clearfix">
      <router-link tag="li" v-for="(item,index) in sensors" :key="index" :to="{path:'/waterParameterDetail',query:{index:index,name:item.name}}" >
        <div :ref="'item'+index" :id="item.iotName" style="position:relative;height:220px;width:220px;margin:0 auto;cursor:pointer"></div>
        <p class="edit" @click.stop="edit(item)">修改</p>
      </router-link>
      <!-- <router-link tag="li" to="/" v-if="videoMonitor">
        <div ref="nitrite" id="kk" style="height:200px;width:220px;margin:0 auto;cursor:pointer"></div>
      </router-link>
      <router-link tag="li" to="/" v-if="videoMonitor">
        <div ref="ammonia" id="kk" style="height:200px;width:220px;margin:0 auto;cursor:pointer"></div>
      </router-link> -->

    </ul>
    <dialog-box :titleName="titleName" :showDialog="showDialog" :dialogWidth="dialogWidth" @changeShow="changeShow">
      <div>
        <span class="name">名称</span><el-input class="input-name" v-model="waterParams.name" placeholder="请输入名称"></el-input>
      </div>
      <div>
        <span class="scopeValue">合理值</span>
        <el-input style="width:200px;" class="input-name" type="number" v-model="waterParams.lowerLimit" placeholder="最小值"></el-input>
        <span class="dash">-</span>
        <el-input style="width:200px;" class="input-name" type="number" v-model="waterParams.upperLimit" placeholder="最大值"></el-input>
      </div>
      <div >
        <el-button type="primary" style="margin-left:80px;" @click="save" >保存</el-button>
      </div>

    </dialog-box>
  </div>
</template>

<script>
import DialogBox from '../common/DialogBox'
import echarts from 'echarts'
import indexModule from '../../store/modules/index'
import equipmentSocketModule from '../../store/modules/equipmentSocket'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'WaterParameter',
  components: {
    DialogBox
  },
  data () {
    return {
      list: {},
      showDialog: false,
      titleName: '编辑水质参数',
      dialogWidth: '600px',
      waterParams: {
        id: '',
        name: '',
        upperLimit: 0, // 合理最大值
        lowerLimit: 0, // 合理最小值
        maxLimit: '', // 最大值
        minLimit: '' // 最小值
      },
      select: '',
      unit: ['mg/l', '°C', '', 'mV']
    }
  },
  watch: {
    sensors () {
      this.echartInit()
    }
  },
  mounted () {
    // this.nitrite()
    // this.ammonia()
  },
  computed: {
    ...mapState(indexModule, ['videoMonitor', 'equipmentId']),
    ...mapState(indexModule, ['equipment']),
    ...mapState(equipmentSocketModule, ['sensors'])
  },
  methods: {
    ...mapActions(equipmentSocketModule, ['indexUpdateSensor', 'getEquipmentSocket']),
    nitrite () {
      let myChart = this.$echarts.init(this.$refs.nitrite)
      myChart.setOption({
        tooltip: {
          formatter: '{b} : {c}mg/l'
        },
        grid: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 0
        },
        series: [

          {
            name: 45,
            type: 'gauge',
            startAngle: 195,
            endAngle: -15,
            // radius: '90%',
            center: ['50%', '60%'],
            splitNumber: 6,
            min: 31,
            max: 45,
            axisLabel: { // 坐标轴小标记
              show: true,
              // 刻度取整
              formatter: function (v) {
                return v.toFixed(0)
              },
              textStyle: { // 属性lineStyle控制线条样式
                fontWeight: 'bolder',
                color: '#728ba1'
                // shadowColor: '#fff' // 默认透明
                // shadowBlur: 1
              }
            },
            boundaryGap: [ 0, 0.1 ],
            axisTick: { // 坐标轴小标记
              length: 8, // 属性length控制线长
              lineStyle: { // 属性lineStyle控制线条样式
                color: 'auto'
                // shadowColor: '#fff' // 默认透明
                // shadowBlur: 5
              }
            },
            splitLine: { // 分隔线
              length: 15, // 属性length控制线长
              lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
                width: 1,
                color: '#728ba1'
                // shadowColor: '#fff', // 默认透明
                // shadowBlur: 5
              }
            },
            axisLine: { // 坐标轴线
              lineStyle: { // 属性lineStyle控制线条样式
                color: [[0.18, '#728ba1'], [0.82, '#728ba1'], [1, '#728ba1']],
                width: 5
                // shadowColor: '#fff', // 默认透明
                // shadowBlur: 10
              }
            },
            pointer: { // 指针样式
              length: '80%',
              width: 3,
              shadowColor: '#728ba1', // 默认透明
              shadowBlur: 3
            },
            itemStyle: {
              color: '#728ba1'
            },
            cursor: 'pointer',
            title: {
              offsetCenter: [0, '55%'],
              textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: 'bolder',
                fontSize: 20,
                color: '#9a9da2',
                shadowColor: '#fff', // 默认透明
                shadowBlur: 2
              }
            },
            detail: {
              formatter: '{value}mg/l',
              offsetCenter: [0, '100%'],
              height: 20,
              textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: '',
                color: '#9a9da2',
                fontSize: 14
              },
              rich: {
                score: {
                  color: 'white',
                  fontFamily: '微软雅黑',
                  fontSize: 14
                }
              }
            },
            data: [{ value: 0, name: '亚硝酸盐' }]
          }

        ]
      })
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
    ammonia () {
      let myChart = this.$echarts.init(this.$refs.ammonia)
      myChart.setOption({
        tooltip: {
          formatter: '{b} : {c}mg/l'
        },
        grid: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 0
        },
        series: [

          {
            name: 45,
            type: 'gauge',
            startAngle: 195,
            endAngle: -15,
            // radius: '90%',
            center: ['50%', '60%'],
            splitNumber: 6,
            min: 31,
            max: 45,
            axisLabel: { // 坐标轴小标记
              show: true,
              // 刻度取整
              formatter: function (v) {
                return v.toFixed(0)
              },
              textStyle: { // 属性lineStyle控制线条样式
                fontWeight: 'bolder',
                color: '#728ba1'
                // shadowColor: '#fff' // 默认透明
                // shadowBlur: 1
              }
            },
            boundaryGap: [ 0, 0.1 ],
            axisTick: { // 坐标轴小标记
              length: 8, // 属性length控制线长
              lineStyle: { // 属性lineStyle控制线条样式
                color: 'auto'
                // shadowColor: '#fff' // 默认透明
                // shadowBlur: 5
              }
            },
            splitLine: { // 分隔线
              length: 15, // 属性length控制线长
              lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
                width: 1,
                color: '#728ba1'
                // shadowColor: '#fff', // 默认透明
                // shadowBlur: 5
              }
            },
            axisLine: { // 坐标轴线

              lineStyle: { // 属性lineStyle控制线条样式
                color: [[0.18, '#728ba1'], [0.82, '#728ba1'], [1, '#728ba1']],
                width: 5
                // shadowColor: '#fff', // 默认透明
                // shadowBlur: 10
              }
            },
            pointer: { // 指针样式
              length: '80%',
              width: 3,
              shadowColor: '#728ba1', // 默认透明
              shadowBlur: 3
            },
            itemStyle: {
              color: '#728ba1'
            },
            cursor: 'pointer',
            title: {
              offsetCenter: [0, '55%'],
              textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: 'bolder',
                fontSize: 20,
                color: '#9a9da2',
                shadowColor: '#9a9da2', // 默认透明
                shadowBlur: 2
              }
            },
            detail: {
              formatter: '{value}mg/l',
              offsetCenter: [0, '100%'],
              height: 20,
              textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: '',
                color: '#9a9da2',
                fontSize: 14
              },
              rich: {
                score: {
                  color: 'white',
                  fontFamily: '微软雅黑',
                  fontSize: 14
                }
              }
            },
            data: [{ value: 0, name: '氨氮' }]
          }

        ]
      })
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
    changeShow () {
      this.showDialog = false
    },
    edit (item) {
      console.log(item)
      this.waterParams.id = item.id
      this.waterParams.upperLimit = item.upperLimit
      this.waterParams.lowerLimit = item.lowerLimit
      this.waterParams.maxLimit = item.maxLimit
      this.waterParams.minLimit = item.minLimit
      this.waterParams.name = item.name
      this.showDialog = true
    },
    // 保存
    save () {
      this.waterParams.upperLimit = +this.waterParams.upperLimit
      this.waterParams.lowerLimit = +this.waterParams.lowerLimit
      if (this.waterParams.lowerLimit > this.waterParams.upperLimit) {
        this.$Alert.info({
          content: '最小值不能大于最大值',
          duration: 3000,
          status: 'error'
        })
        return
      }
      if (this.waterParams.lowerLimit < this.waterParams.minLimit || this.waterParams.upperLimit > this.waterParams.maxLimit) {
        this.$Alert.info({
          content: `取值范围不能超出${this.waterParams.minLimit} ~ ${this.waterParams.maxLimit}`,
          duration: 3000,
          status: 'error'
        })
        return
      }

      try {
        this.indexUpdateSensor([this.waterParams]).then(async data => {
          console.log(data)
          this.showDialog = false
          await this.getEquipmentSocket({
            id: this.equipmentId,
            isGetRealTimeData: true
          })
        })
      } catch (err) {
        console.log('失败')
      }
    },
    echartInit () {
      this.$nextTick(function () {
        for (let i = 0; i < this.sensors.length; i++) {
          // var item = 'item' + i
          // console.log(item)
          var echartObj = this.$refs['item' + i][0]
          let myChart = this.$echarts.init(echartObj)
          myChart.setOption({
            tooltip: {
              formatter: '{b} : {c}mg/l'
            },
            grid: {
              x: 0,
              y: 0,
              x2: 0,
              y2: 0
            },
            series: [

              {
                name: this.sensors[i].name,
                type: 'gauge',
                startAngle: 220, // 开始角度
                endAngle: -40, // 结束角度
                // radius: '80%',
                center: ['55%', '45%'],
                splitNumber: 6,
                min: this.sensors[i].minLimit,
                max: this.sensors[i].maxLimit,
                axisLabel: { // 坐标轴小标记
                  show: true,
                  // 刻度取整  小数点1位
                  formatter: function (v) {
                    return v.toFixed(1)
                  },
                  textStyle: { // 属性lineStyle控制线条样式
                    fontWeight: 'bolder',
                    color: '#fff'
                    // shadowColor: '#fff' // 默认透明
                    // shadowBlur: 1
                  }
                },
                boundaryGap: [ 0, 0.1 ],
                axisTick: { // 坐标轴小标记
                  length: 8, // 属性length控制线长
                  lineStyle: { // 属性lineStyle控制线条样式
                    color: 'auto'
                    // shadowColor: '#fff' // 默认透明
                    // shadowBlur: 5
                  }
                },
                splitLine: { // 分隔线
                  length: 15, // 属性length控制线长
                  lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
                    width: 1,
                    color: '#fff'
                    // shadowColor: '#fff', // 默认透明
                    // shadowBlur: 5
                  }
                },
                axisLine: { // 坐标轴线
                  lineStyle: { // 属性lineStyle控制线条样式
                    // color: [[0.18, 'lime'], [0.82, '#1e90ff'], [1, '#ff4500']],
                    color: [
                      [ 0.2, new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                        offset: 0,
                        color: '#FF0000' // 50% 处的颜色
                      }, {
                        offset: 1,
                        color: '#FFCB4E' // 40% 处的颜色
                      }], false) ], // 100% 处的颜色
                      [ 0.8, new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#7AFF70' // 70% 处的颜色
                      }, {
                        offset: 1,
                        color: '#24FE00' // 66% 处的颜色
                      }], false) ],
                      [1, new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {
                        offset: 0,
                        color: '#FFCB4E' // 92% 处的颜色
                      }, {
                        offset: 1,
                        color: '#FF0000' // 90% 处的颜色
                      }], false) ]
                    ],
                    width: 5
                    // shadowColor: '#fff', // 默认透明
                    // shadowBlur: 10
                  }
                },
                pointer: { // 指针样式
                  length: '80%',
                  width: 3,
                  shadowColor: '#fff', // 默认透明
                  shadowBlur: 3
                },
                itemStyle: {
                  color: '#fff'
                },
                cursor: 'pointer',
                title: {
                  offsetCenter: [0, '90%'],
                  textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                    fontWeight: 'normal',
                    fontSize: 20,
                    color: '#00c6ff',
                    shadowColor: '#fff', // 默认透明
                    shadowBlur: 2
                  }
                },
                detail: {
                  formatter: `{value}${this.sensors[i].unitTitle ? this.sensors[i].unitTitle : ''}`,
                  offsetCenter: [0, '124%'],
                  height: 20,
                  textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                    fontWeight: '',
                    color: '#fefefe',
                    fontSize: 14
                  },
                  rich: {
                    score: {
                      color: 'white',
                      fontFamily: '微软雅黑',
                      fontSize: 14
                    }
                  }
                },
                data: [{ value: this.sensors[i].currentValue, name: this.sensors[i].name }]
              }

            ]
          })
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.water-parameter canvas
  cursor pointer
.el-input
  display inline-block
  width 200px

  .el-input__inner
    border 1px solid #07f
    color #BBD4E9
    background #203051
.el-dialog__body
  padding: 40px;
  >div
    margin-top 24px
  .dash
    display inline-block
    width 20px
    height 20px
    text-align: center;
    color #07f
  .name,.scopeValue,.upload-image
    width 60px
    text-align right
    color #BBD4E9
    margin-right 20px
  .input-name
    width 420px
  .el-button--primary
    color: #fff;
    background-color: #07f;
    margin-left: 10px;
    padding: 10px 30px;
    border-radius 4px
    border 0
</style>

<style lang="stylus" scoped>
  .water-parameter

    .title
      position relative
      margin 0 0 0 20px
      border-bottom 1px solid #148eff
      .parallelogram
        text-align center
        span
          transform:skew(15deg);
          line-height 44px
          font-size 16px
          color #fff
    ul
      padding 18px 0
    li
      position relative
      float left
      width 50%
      margin-bottom 10px
      text-align center
      cursor pointer
      img
        width 123px
        height 100px
      .oxygen
        font-size 16px
        color #00A2FF
      .capacity
        font-size 12px
        color #BBD4E9
      .edit
        margin-top -10px
        font-size 14px
        color #FF402C
        cursor pointer
        position: absolute;
        left: 49%;
</style>
